var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFewClouds(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #ffcb05;\n      }\n\n      .cls-1, .cls-2 {\n        stroke-width: 0px;\n      }\n\n      .cls-2 {\n        fill: #fff;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m11.5,4h-2V1c0-.6.4-1,1-1h0c.6,0,1,.4,1,1v3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m19,10.5h-3v-2h3c.6,0,1,.4,1,1h0c0,.6-.4,1-1,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m15.1,6.3l-1.4-1.4,2.1-2.1c.4-.4,1-.4,1.4,0h0c.4.4.4,1,0,1.4l-2.1,2.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m5.9,6.3l-2.1-2.1c-.4-.4-.4-1,0-1.4h0c.4-.4,1-.4,1.4,0l2.1,2.1-1.4,1.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m6.9,10.88c.8,0,1.52.34,2.02,1.04.1.2.29.31.49.31.3,0,.49.27.59.07.1-.1-.06-.3.14-.4-1.3-.1-2.14-1-2.14-2.4s1.1-2.5,2.5-2.5,2.5,1.1,2.5,2.5c0,.8-.4,1.51-.99,1.98-.3.24.07.3-.3.4.3.1.34.14.34.54,0,.1.26,0,.16.2-.1.1-.03.43-.03.53,0,.2-.19.24-.09.34.32-.08.13.12.42-.02,1.5-.73,2.49-2.22,2.49-4.07,0-2.4-2-4.4-4.5-4.4s-4.5,2-4.5,4.5c0,.35.03.71.1,1.04.05.23.15.21.23.42.2,0,.36-.08.56-.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m6.9,11.1c-1.2,0-2.2.9-2.2,2.2v.1c0,.4-.3.7-.6.7-1.1.1-1.9.9-1.9,2,.1,1.1,1,1.9,2,1.9h7.7c1.1-.1,1.9-.9,1.9-2-.1-.9-.8-1.7-1.6-1.8-.4-.1-.6-.4-.6-.8q0-.1.1-.2c.1-.2.1-.3.1-.4,0-.5-.4-.9-.9-.9-.3,0-.6.1-.7.4s-.4.3-.6.3-.4-.1-.6-.4c-.6-.7-1.3-1.1-2.1-1.1Zm5.5,8.9H3.8c-2.1,0-3.8-1.7-3.8-3.8,0-1.8,1.2-3.2,2.8-3.7.2-2,2-3.4,4-3.4,1,0,2.1.4,2.8,1.2,1.2-.7,2.8-.4,3.6.8.2.5.4,1,.4,1.4v.2c1.9.7,2.9,2.9,2.2,4.9-.5,1.4-1.7,2.2-3.1,2.4h-.3Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFewClouds);
export default __webpack_public_path__ + "static/media/few_clouds.f1b416901da1889f7f3c6873fbcbefa9.svg";
export { ForwardRef as ReactComponent };